import { render, staticRenderFns } from "./SummaryReceipt.vue?vue&type=template&id=479cc7a8&scoped=true&"
import script from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
export * from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryReceipt.vue?vue&type=style&index=0&id=479cc7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cc7a8",
  null
  
)

export default component.exports